import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {AuthService} from '@shared/services/auth.service';
import {Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class IsMasterOrAdminUserGuard implements CanActivate {

    constructor(private authService: AuthService,
                private router: Router) {
    }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.checkIfMasterOrAdminUser();
    }

    checkIfMasterOrAdminUser(): boolean | Promise<boolean> {
        if (this.authService.isMasterUser() || this.authService.isAdminUser()) {
            return true;
        } else {
            return this.router.navigate(['fehler', '403']);
        }
    }
}
